import { QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";

import { DisplayIntroLogo } from "@features/DisplayIntroLogo";

import { ToastManager } from "@components/Toast";
import { TooltipProvider } from "@components/Tooltip";

import { DialogManager } from "@services/DialogManager";

import { installBrowserTranslateGuard } from "@lib/browserTranslateGuard";
import { createQueryClient } from "@lib/queryClient";

import { ENV_CONFIG } from "@configs/env";

import "./index.css";
import { router } from "./routes";

// Must run before the first React render — see browserTranslateGuard for details.
installBrowserTranslateGuard();

// eslint-disable-next-line no-console -- Startup diagnostics are intentionally printed once per page load.
console.info(
	`%c🚀 Model Dashboard %cv${__APP_VERSION__}`,
	"font-weight: bold; font-size: 14px; color: #a78bfa;",
	"font-weight: bold; font-size: 14px; color: #c4b5fd;",
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<QueryClientProvider client={createQueryClient}>
		<TooltipProvider>
			<DisplayIntroLogo />
			<DialogManager />
			<ToastManager />
			<RouterProvider router={router} />
		</TooltipProvider>
	</QueryClientProvider>,
);
